import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const gradientMove = keyframes`
  0% { background-position: 0% center; }
  50% { background-position: 100% center; }
  100% { background-position: 0% center; }
`

export const SliderContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  .slick-arrow {
    height: 40px;
    background-color: #fff;
    color: black;
    border-radius: 50%;
    width: 40px;
    opacity: 1;
    margin-inline: 30px;
  }
  .slick-prev::after {
    position: absolute;
    top: 39%;
    left: 39%;
    font-size: 24px;
  }
  .slick-next::after {
    position: absolute;
    top: 39%;
    left: 31%;
    font-size: 24px;
  }
  @media screen and (max-width: 500px) {
    .slick-arrow {
      width: 30px;
      height: 30px;
      font-size: 18px;
      margin-inline: 0;
    }
    .slick-prev::after {
      position: absolute;
      top: 40%;
      left: 39%;
      width: 8px;
      height: 8px;
    }
    .slick-next::after {
      position: absolute;
      top: 39%;
      left: 31%;
      width: 8px;
      height: 8px;
    }
  }
`

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
`

export const SlideImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(3, 8, 82, 0.6);
    z-index: 2;
  }
`

export const SlideTitle = styled.h2`
  position: relative;
  z-index: 3;
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(90deg, #ffa645, rgb(236, 216, 154), #ffa645);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${fadeInUp} 0.8s ease-out, ${gradientMove} 3s ease infinite;
  margin: 0;
  @media screen and (max-width: 450px) {
    font-size: 1.5rem;
  }
`

export const SlideLocation = styled.p`
  position: relative;
  z-index: 3;
  font-size: 18px;
  color: #ffffff;
  margin-top: 10px;
  animation: ${fadeInUp} 1s ease-out;
`
export const Title = styled.p`
  font-size: 1.5rem;
  color: #ffffff;
  margin: 0;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #ffffff;
  }

  @media screen and (max-width: 750px) {
    font-size: 14px;
  }
`

export const OverlayHeader = styled.div`
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  pointer-events: none;
  .subtitle {
    font-size: 2.3rem;
  }
  padding-top: 60px;
  @media screen and (max-width: 750px) {
    .subtitle {
      font-size: 1.5rem;
    }
  }
  @media screen and (max-width: 450px) {
    .subtitle {
      font-size: 1.2rem;
    }
  }
  @media screen and (max-width: 395px) {
    width: 200px;
    .subtitle {
      font-size: 1rem;
    }
  }
`
